<template>
  <a
    @click="openService"
    class="service-icon-btn j-service-float-btn"
    :class="[isShowBtn ? 'show' : false, $platformClass]"
    @mouseenter="isShowBtn = true"
    href="javascript:;"
    v-if="needBtn"
  ></a>
</template>

<script>
import bridge from '../utiles/bridge';
import { FEEKBACK_URL } from '../utiles';
import globalConfig from '../utiles/globalConfig';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
import { clickButton } from '@plugins/biPoint/_configSdkstore';
const mainHost = globalConfig.getMainHost();
export default {
  data() {
    return {
      needBtn: globalConfig.getHrefParam('hideService') != 1,
      isShowBtn: false,
      timer: null
    };
  },
  props: ['serverId', 'roleId', 'roleName', 'gameId'],
  watch: {
    isShowBtn(newV, oldV) {
      if (newV) {
        this.timer = setTimeout(() => {
          clearTimeout(this.timer);
          this.timer = null;
          this.isShowBtn = false;
        }, 2000);
      } else {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }
    }
  },
  methods: {
    openService() {
      clickButton({
        btnName: 'customer_service',
        locationKey: this.$route.meta.pageName
      });
      if (this.isShowBtn) {
        let realPage = FEEKBACK_URL;
        if (globalConfig.getHrefParam('packageName') == '') {
          realPage = `https://gabres.${mainHost}/platform/webSupport.html?gameId=${
            this.gameId || ''
          }&serverId=${this.serverId || ''}&roleId=${
            this.roleId || ''
          }&roleName=${encodeURIComponent(this.roleName) || ''}`;
          window.open(getGlobalGetGotoLink({ link: realPage }), '_blank');
        } else {
          bridge.callSdkMethod('openBrowser', {
            url: getGlobalGetGotoLink({ link: realPage }),
            loginDir: 1,
            appendParams: 1
          });
        }
      } else {
        this.isShowBtn = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/_dimen.scss';
.service-icon-btn {
  $w: 80px;
  position: fixed;
  background-size: contain;
  width: $w;
  height: $w;
  right: -0.5 * $w;
  bottom: 36vh;
  border-radius: 100%;
  transition: all 0.2s;
  background-image: url('../assets/image/support/potrait-service.png');
  box-shadow: 0px 0px 14px 1px #c5c5c5;
  cursor: auto;
  &.show {
    right: 0;
  }
  &:hover {
    cursor: pointer;
  }
}
@media screen and (orientation: landscape) and (max-width: 1000px) {
  .service-icon-btn {
    width: 50px;
    height: 50px;
    right: -20px;
  }
}
</style>
